import { createTheme, ThemeOptions } from "@mui/material/styles";

export const themeOptions: ThemeOptions = {
  palette: {
    mode: "light",
    primary: {
      // main: "#ff5722",
      main: "#303344",
    },
    secondary: {
      main: "#0288d1",
    },
    error: {
      main: "#ff9800",
    },
    warning: {
      main: "#ffeb3b",
    },
    info: {
      main: "#ff5722",
    },
  },
  typography: {
    fontFamily: "Nunito",
  },
  spacing: 8,
};
